const MESSAGE = 'Bad request.';

export class BadRequestError extends Error {
  constructor() {
    super(MESSAGE);
  }
}
